module.exports = __webpack_public_path__ + "img/versapay-interviews-2.8fac9603.png";